import type { CSSProperties } from "react";
import { colors, fontSize, fontWeight, lifecycleBadgeColor, radius } from "../lib/tokens";

const STATE_LABELS: Record<string, string> = {
  prospect: "Prospect",
  trial: "Trial",
  active: "Active",
  delinquent: "Delinquent",
  suspended: "Suspended",
  churned: "Churned",
  archived: "Archived",
};

interface BadgeProps {
  state?: keyof typeof lifecycleBadgeColor;
  label?: string;
  color?: string;
  bg?: string;
}

export function Badge({ state, label, color, bg }: BadgeProps) {
  const palette = state ? lifecycleBadgeColor[state] : null;
  const fg = color ?? palette?.fg ?? colors.stone;
  const background = bg ?? palette?.bg ?? colors.fog;
  const dot = palette?.dot ?? fg;
  const text = label ?? (state ? STATE_LABELS[state] : "");

  const style: CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    padding: "3px 8px",
    borderRadius: radius.pill,
    fontSize: fontSize.xs,
    fontWeight: fontWeight.medium,
    lineHeight: 1.4,
    color: fg,
    background,
    border: "1px solid transparent",
  };
  const dotStyle: CSSProperties = {
    width: 6, height: 6, borderRadius: "50%", background: dot,
  };
  return (
    <span style={style}>
      <span style={dotStyle} />
      {text}
    </span>
  );
}
